import { AfterViewInit, Directive, ElementRef, inject, input, InputSignal, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { SwiperContainer } from 'swiper/swiper-element';
import { SwiperOptions } from 'swiper/types';

@Directive({
  selector: '[braidsbookSwiper]'
})
export class SwiperDirective implements AfterViewInit {
  swiperContainer: SwiperContainer = inject(ElementRef<SwiperContainer>).nativeElement;
  swiperOptions: InputSignal<SwiperOptions | undefined> = input<SwiperOptions | undefined>(undefined);

  readonly #platformId = inject(PLATFORM_ID);


  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.#platformId) && !this.swiperContainer.swiper) {
      Object.assign(this.swiperContainer, this.swiperOptions());
      this.swiperContainer.initialize();
    }
  }

}
